import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { CheckCircle, XCircle, Loader2, Mail } from "lucide-react";
import { Button } from "../components/ui/button";

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus("error");
      setMessage("No se encontró el token de verificación");
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API}/auth/verify-email?token=${token}`);
      setStatus("success");
      setMessage(response.data.message);
    } catch (error) {
      setStatus("error");
      setMessage(error.response?.data?.detail || "Error al verificar el correo");
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <Link to="/" className="inline-block mb-6">
          <img src="/logo-marketvalley.png" alt="Clueer" className="h-9 mx-auto" />
        </Link>
        
        {status === "loading" && (
          <div className="py-8">
            <Loader2 size={64} className="mx-auto text-[#F97316] animate-spin mb-4" />
            <h2 className="text-xl font-semibold text-[#0F172A] mb-2">
              Verificando tu correo...
            </h2>
            <p className="text-[#64748B]">
              Por favor espera un momento
            </p>
          </div>
        )}
        
        {status === "success" && (
          <div className="py-8">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={48} className="text-green-500" />
            </div>
            <h2 className="text-xl font-semibold text-[#0F172A] mb-2">
              ¡Correo Verificado!
            </h2>
            <p className="text-[#64748B] mb-6">
              {message}
            </p>
            <Button 
              onClick={() => navigate("/login")}
              className="rounded-full bg-[#F97316] hover:bg-[#EA580C] text-white px-8"
            >
              Iniciar Sesión
            </Button>
          </div>
        )}
        
        {status === "error" && (
          <div className="py-8">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle size={48} className="text-red-500" />
            </div>
            <h2 className="text-xl font-semibold text-[#0F172A] mb-2">
              Error de Verificación
            </h2>
            <p className="text-[#64748B] mb-6">
              {message}
            </p>
            <div className="space-y-3">
              <Button 
                onClick={() => navigate("/login")}
                className="rounded-full bg-[#475569] hover:bg-[#334155] text-white px-8 w-full"
              >
                Ir a Iniciar Sesión
              </Button>
              <p className="text-sm text-[#94A3B8]">
                Si el enlace expiró, inicia sesión y solicita un nuevo correo de verificación
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
